var map = {
	"./Icon-check.svg": "3484",
	"./add-icon.svg": "ff23",
	"./altay-logo.svg": "8b06",
	"./arrow-button-left.svg": "cf7c",
	"./arrow-button-right.svg": "aee7",
	"./arrow-down.svg": "4194",
	"./arrow-dropdown.svg": "507b",
	"./arrow-right-icon.svg": "d4b8",
	"./astrakhan-logo.svg": "c90f",
	"./avatar-insurance-empty.svg": "5af0",
	"./basePage/baloon-icon.svg": "890e",
	"./buryatia-logo.svg": "ddc2",
	"./calendar-2.svg": "08bf",
	"./check.svg": "fa1d",
	"./check_mark.svg": "1c2d",
	"./clear_icon.svg": "da6a",
	"./clinic-icon.svg": "64d7",
	"./clouds-icon.svg": "0a26",
	"./cross-blue.svg": "b2187",
	"./cross.svg": "2945",
	"./dagestan-logo.svg": "c7cb",
	"./delete_icon.svg": "2c6f",
	"./document_icon.svg": "985c",
	"./edit_icon.svg": "f042",
	"./ekat-logo.svg": "e80f",
	"./empty-avatar.svg": "d5f3",
	"./esia.svg": "135c",
	"./exel_icon.svg": "164f",
	"./eye_1.svg": "e16e",
	"./favorite-icons/heart-fill_default.svg": "30ab",
	"./favorite-icons/heart-fill_hover.svg": "70db",
	"./favorite-icons/heart_default.svg": "d233",
	"./favorite-icons/heart_hover.svg": "7949",
	"./filter.svg": "0a39",
	"./fmba-logo.svg": "5596",
	"./gemotest_logo.svg": "188d",
	"./gostelemed-logo.svg": "67cac",
	"./guarantee_letter.svg": "e786",
	"./icon-bi-check.svg": "b995",
	"./icon-cross.svg": "92b2",
	"./icon-empty.svg": "2f06",
	"./icon-left.svg": "d23c",
	"./icon-maintaince.svg": "a3d3",
	"./icon_carry.svg": "6e27",
	"./icon_chat.svg": "ffee",
	"./icon_close.svg": "b9f9",
	"./icon_close_with_border.svg": "919a",
	"./icon_delete.svg": "0738",
	"./icon_dropdown_arrow.svg": "10ee",
	"./icon_gosuslugi.svg": "1152",
	"./icon_history.svg": "7b21",
	"./icon_mango.svg": "2fc2",
	"./icon_reload.svg": "0da5",
	"./icon_top.svg": "54e8",
	"./icon_vip.svg": "ca68",
	"./indemnity-arrow-icon.svg": "033a",
	"./info.svg": "d059",
	"./info_icon.svg": "6c6e",
	"./input-arrow-down.svg": "111f",
	"./input-arrow-up.svg": "0943",
	"./knowledge-base-back.svg": "a8f7",
	"./knowledge-base-book.svg": "888a",
	"./knowledge-base-checklist.svg": "1225",
	"./knowledge-base-community.svg": "86a2",
	"./knowledge-base-contact-book.svg": "a0b7",
	"./knowledge-base-gosuslugi.svg": "a264",
	"./knowledge-base-instructions.svg": "039c",
	"./knowledge-base-telemed.svg": "09f4",
	"./krym-logo.svg": "7709",
	"./kurgan-logo.svg": "2e34",
	"./letter-icon.svg": "563b",
	"./letter_icon.svg": "d317",
	"./logout.svg": "1f08",
	"./mariel-logo.svg": "f5c2",
	"./message.svg": "d9dc",
	"./minimize.svg": "4ba4",
	"./mobile-check.svg": "ae2d",
	"./mobile-not-check.svg": "ed74",
	"./msk-logo.svg": "0af9",
	"./nino-logo.svg": "2a97",
	"./penza-logo.svg": "207e",
	"./photo-avatar.svg": "e4d3",
	"./plus-row-icon.svg": "b954",
	"./policy-services.svg": "c9e9",
	"./remote-monitoring/IconBiClinics.svg": "c8a6",
	"./remote-monitoring/IconBiDoctors.svg": "7ffa",
	"./remote-monitoring/IconBiEffective.svg": "0d81",
	"./remote-monitoring/IconBiFailures.svg": "7727",
	"./remote-monitoring/IconBiPatients.svg": "811e",
	"./remote-monitoring/icon-cell-pause.svg": "3386",
	"./remote-monitoring/icon-emergency.svg": "5586",
	"./remote-monitoring/icon-info.svg": "f6f7",
	"./schedule_arrow_left.svg": "652f",
	"./schedule_arrow_right.svg": "d738",
	"./search.svg": "cbef",
	"./select_arrow.svg": "a260",
	"./services.svg": "4f72",
	"./three-dots.svg": "3fbd",
	"./unpin-icon.svg": "bb19",
	"./user-with-buble.svg": "eae4",
	"./user.svg": "fa85",
	"./watch_icon.svg": "286c",
	"./worksheet.svg": "959d",
	"./yamal-logo.svg": "f29d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";